<template>
  <div fluid class="pa-0 ma-0">
    <div class="flex justify-center h-screen">
      <!-- Left panel will go here -->
      <!-- Added vuetify classes, helper classes check documentation https://vuetifyjs.com/en/styles/display/#display -->
      <div class="hidden sm:flex md:!w-1/3 sm:!w-1/2">
        <CarouselVue :images="$store.getters.uniLeft" />
      </div>
      <div class=" h-screen d-xs-block flex justify-center md:!w-1/3 sm:!w-1/2 w-100 bg-black">
        <!-- <v-row>
          <v-col>
            <MiniPlayer />
            <MusicPlayer />
          </v-col>
        </v-row> -->
        <v-card no-gutters
          class=" !overflow-auto d-flex align-center justify-start flex-col bg-black border-0 h-full sm:w-full w-[420px]" elevation="0"
          flat rounded="0">
          <v-avatar tile height="100" width="150" class="!overflow-visible">
            <img class="" :src="require('@/assets/img/Logo/logo.gif')" />
          </v-avatar>
          <v-form class="w-5/6 mt-8" v-model="isFormValid">
            <div class="">
              <h1 class="mb-6 text-2xl font-bold uppercase font-Handel for-bg">
                Forgot Password
              </h1>
              <div>
                <p class="text-slate-300 font-Handel">
                  You Can Reset Your Password Here
                </p>
                <v-text-field v-model="email" :rules="emailRules" outlined :disabled="otpSent"
                  class="border-0 !rounded-none text-red font-Handel text-red " color="#b99143" dark
                  placeholder="Enter Your Email Address" required></v-text-field>
              </div>
              <v-expand-transition>
                <div class="" v-if="otpSent">
                  <p class="text-slate-300 font-Handel">
                    Enter OTP Here
                  </p>
                  <v-otp-input v-model="otp" class="otp_verify font-Handel" type="number" length="4"
                    :disabled="verifyOtpLoading || otpVerified" @finish="onVerifyOtp"></v-otp-input>

                </div>
              </v-expand-transition>
              <v-expand-transition>
                <div class="" v-if="otpVerified">
                  <p class="text-slate-300 font-Handel">
                    Enter New Password Here
                  </p>
                  <v-text-field v-model="password" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]" :type="showPassword ? 'text' : 'password'" name="input-10-1"
                    counter @click:append="showPassword = !showPassword" placeholder="Enter New Password"
                    class="border-0 !rounded-none text-red font-Handel text-red " outlined color="#b99143"
                    dark></v-text-field>
                </div>
              </v-expand-transition>
              <v-expand-transition>
                <div class="" v-if="otpVerified">
                  <p class="text-slate-300 font-Handel">
                    Confirm Password Here
                  </p>
                  <v-text-field :type="showPassword ? 'text' : 'password'" v-model="password_confirmation"
                    :rules="[[v => !!v || 'Password is required'], (password === password_confirmation) || 'Password must match']"
                    outlined class="border-0 !rounded-none text-red font-Handel" color="#b99143" dark
                    placeholder="Confirm Password" required></v-text-field>
                </div>
              </v-expand-transition>
            </div>
            <v-row class="" no-gutters>
              <v-col>
                <v-btn :loading="!otpSent ?  forgotLoading : !otpVerified ? verifyOtpLoading : setPasswordLoading" :disabled="!isFormValid"
                  class="!w-full font-Handel !mb-5 font-xl rounded-0 white--text bg-gradient-to-tl from-[#553900] via-[#ebae33] to-[#553900] hover:opacity-90"
                  text large @click.prevent=" !otpVerified ? forgotPassword() : changePassword()">
                  {{ !otpSent ? 'Forgot Password' : otpVerified ? 'Set New Password' : 'Verify OTP' }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </div>
      <!-- Right panel will go here -->
      <div class="hidden w-1/3 md:flex">
        <CarouselVue :images="$store.getters.uniRight" />
      </div>
    </div>
  </div>
</template>

<script>
import CarouselVue from "../../../components/auth/Carousel.vue";
import axios from "axios";
export default {
  components: {
    CarouselVue,
  },
  data() {
    return {
      txt: "",
      // data
      email: "",
      password: '',
      password_confirmation: '',
      otp: '',
      // for conditions
      otpSent: false,
      otpVerified: false,
      // for loading
      forgotLoading: false,
      verifyOtpLoading: false,
      setPasswordLoading: false,

      //  for validation
      showPassword: false,
      isFormValid: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    };
  },
  methods: {
    async forgotPassword() {
      try {
        this.forgotLoading = true;
        const resp = await axios({
          url: "auth/send/email",
          method: "POST",
          data: {
            email: this.email,
          },
        });
        this.txt = resp.data.message;
        console.log(this.txt)
        this.$toast(resp.data.message, {
          position: "top-center",
          timeout: 3000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: true,
          hideProgressBar: true,
          closeButton: "button",
          icon: {
            iconClass: "mdi mdi-check-all",
            iconChildren: "",
            iconTag: "i"
          },
          rtl: false
        });
        // this.$router.push({ name: "Verify" })
        this.otpSent = true;
      } catch (error) {
        console.error(error);
        await this.$store.dispatch("errorAction", error.response.data.message, {
          root: true,
        })
      } finally {
        this.forgotLoading = false;
      }
    },
    async onVerifyOtp() {
      try {
        this.verifyOtpLoading = true;
        await axios.post('auth/verify/code', {
          email: this.email,
          code: this.otp
        })
        this.otpVerified = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.verifyOtpLoading = false;
      }
    },
    async changePassword() {
      try {
        this.setPasswordLoading = true;
       const resp = await axios.post('auth/new-password', {
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
        })
        this.$toast(resp.data.message, {
          position: "top-center",
          timeout: 3000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: true,
          hideProgressBar: true,
          closeButton: "button",
          icon: {
            iconClass: "mdi mdi-check-all",
            iconChildren: "",
            iconTag: "i"
          },
          rtl: false
        });
        await this.$store.dispatch("LogIn", {
          email: this.email,
          password: this.password,
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.setPasswordLoading = false;
      }
    }

  },
  
};
</script>
<style scoped>
.for-bg {
  background: linear-gradient(350deg,
      rgba(157, 115, 31, 1) 49%,
      rgba(219, 182, 112, 1) 56%,
      rgba(157, 115, 31, 1) 64%,
      rgba(219, 182, 112, 1) 75%,
      rgba(157, 115, 31, 1) 80%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.v-text-field--outlined:deep(fieldset) {
  border-color: #7f6415;
}

.v-text-field--outlined:deep(input) {
  color: #7f6415 !important;
}

.v-text-field--outlined:deep(input::placeholder) {
  color: #7f6415 !important;
}

.v-input--checkbox:deep(.v-input--selection-controls__input) {
  color: #7f6415 !important;
}
.otp_verify:deep(.v-input__slot) {
  border-radius: 10px !important;
}

.v-input--checkbox:deep(label) {
  color: #cbd5e1 !important;
  font-size: 14px;
}

.v-input--checkbox:deep(i) {
  color: #9d731f !important;
}
.v-text-field--outlined:deep(.v-icon) {
  color: #7f6415 !important;
}

.otp_verify:deep(.v-text-field__slot) {
  background: linear-gradient(350deg,
      rgba(157, 115, 31, 1) 0%,
      rgba(219, 182, 112, 1) 50%,
      rgba(157, 115, 31, 1) 100%);
  border: 1px solid black;
  border-radius: 10px;
}

.otp_verify:deep(.v-input--is-focused fieldset) {
  border: none !important;
}

.text-red:deep(input:-webkit-autofill),
.text-red:deep(input:-webkit-autofill:hover),
.text-red:deep(input:-webkit-autofill:focus) {
  -webkit-text-fill-color: #7f6415 !important;
  -webkit-box-shadow: 0 0 0px 40rem rgb(0, 0, 0) inset !important;
}
</style>
